interface IGoogleLoginButtonProps {
  onClick: () => void
}

export const GoogleLoginButton = (props: IGoogleLoginButtonProps) => {
  return (
    <button
      onClick={props.onClick}
      className={
        'flex items-center justify-center cursor-pointer gap-3 w-full max-w-xs px-4 py-4 bg-white rounded-lg shadow-md hover:shadow-lg transition'
      }
    >
      <img
        src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
        alt="Google logo"
        className="w-6 h-6"
      />
      <span className="text-lg font-medium">{'Continue with Google'}</span>
    </button>
  )
}
